// extracted by mini-css-extract-plugin
export default {"root":"lWgi6d"};